import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = "https://zwehgkpubkqgggoimbfc.supabase.co";
const SUPABASE_ANON = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp3ZWhna3B1YmtxZ2dnb2ltYmZjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMzNTU1MjksImV4cCI6MjA4ODkzMTUyOX0.cRMcvunwXCU-kJ6qXx6IYXlo9bX0n0N8QTZBaiEyGN4";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON);
